import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Preview'}</title>
      <g>
        <path d="M507 256.3c0 6.4-1.9 12.8-5.6 19.3-26.1 43-61.3 77.3-105.4 103.2s-90.8 38.8-139.9 38.8-95.7-13-139.9-38.9c-44.1-26-79.3-60.3-105.4-103.1-3.7-6.5-5.6-12.9-5.6-19.3 0-6.3 1.9-12.8 5.6-19.3 26.1-42.8 61.3-77.1 105.4-103.1 44.2-25.9 90.8-38.9 139.9-38.9s95.7 13 139.9 38.9c44.1 26 79.3 60.3 105.4 103.1 3.7 6.5 5.6 13 5.6 19.3zm-35.9 0c-28.4-44.1-63.9-77-106.7-98.9 11.4 19.4 17.1 40.4 17.1 63 0 34.5-12.3 64.1-36.8 88.6-24.5 24.5-54.1 36.8-88.6 36.8s-64.1-12.2-88.6-36.8-36.8-54.1-36.8-88.6c0-22.6 5.7-43.6 17.1-63-42.8 21.8-78.3 54.8-106.7 98.9 24.8 38.3 55.9 68.7 93.4 91.4 37.4 22.7 77.9 34 121.6 34s84.2-11.4 121.6-34c37.5-22.7 68.6-53.1 93.4-91.4zm-205.5-98c2.6-2.6 3.9-5.8 3.9-9.5s-1.3-6.9-3.9-9.5c-2.6-2.6-5.8-3.9-9.5-3.9-23.4 0-43.4 8.3-60.1 25-16.7 16.7-25.1 36.7-25.1 60.1 0 3.8 1.3 6.9 3.9 9.5 2.6 2.7 5.8 3.9 9.6 3.9 3.7 0 6.9-1.3 9.5-3.9 2.6-2.6 3.9-5.8 3.9-9.5 0-16 5.7-29.8 17.1-41.2 11.4-11.4 25.1-17.1 41.2-17.1 3.7 0 6.9-1.3 9.5-3.9z" />
      </g>
    </Icon>
  )
}
